export const BRACELET_COLORS = {
  "1": "#F26D0F",
  "2": "#C40000",
  "3": "#FF84CE",
  "4": "#6A2A9C",
  "6": "#C1298B",
  "5": "#EBB400",
  "7": "#2EAF76",
  "8": "#008DD2",
};

export const BRACELET_NAMES = {
  "1": "Osmium",
  "2": "Eclair",
  "3": "Haswell",
  "4": "Geneva",
  "5": "Falco",
  "6": "Mafalda",
  "7": "Cascades",
  "8": "Warsaw",
};
